import { modificationInfoElement } from '@entities/Auto/module/types/autoSelectsTypes';
import { ProductSpecCode } from '@entities/Product/module/types/productSchema';
import { SideFilterElementTitle } from '@widgets/Filter/templates/shared/sideFilterElementTitle';

import styles from './ModificationInfo.module.scss';
import { sortParamsRecSizes } from '@entities/Auto';

const sortArrayParams = [ProductSpecCode.DiskUnitedPcd, ProductSpecCode.DiskDia, ProductSpecCode.DiskMount, ProductSpecCode.DiskEt];

const handlerTitleParam = (code: ProductSpecCode, title: string): string => {
  return code === ProductSpecCode.DiskDia ? 'Центр. отверстие (Dia)' : title;
};

export const ModificationInfo = ({ modificationInfoElements }: { modificationInfoElements: modificationInfoElement[] }) => {
  if (!modificationInfoElements || modificationInfoElements.length === 0) {
    return null;
  }

  return (
    <div className={styles.Wrapper}>
      <SideFilterElementTitle bold>Параметры авто:</SideFilterElementTitle>
      {modificationInfoElements
        .filter(item => item.code !== ProductSpecCode.DiskEt)
        .sort(sortParamsRecSizes)
        .map(item => (
          <div key={item.code}>
            <SideFilterElementTitle
              className={styles.Element}
              isInfoTooltip={Object.values(ProductSpecCode).includes(item.code)}
              nameTooltip={item.code}
            >
              {handlerTitleParam(item.code, item.title)}
            </SideFilterElementTitle>
            <div>{item.value}</div>
          </div>
        ))}
      <div className={styles.Hr}></div>
    </div>
  );
};
